<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-th-list"></i>
        WFDetector - WSFinder
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WFDetector</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">WSFinder</a>
          </li>
      </ul>
    </div>
    <!-- <router-view @refresh="refresh()"></router-view> -->
    <b-card>
      <b-row>
        <b-col sm="6">
          <!-- <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" /> -->
          <span>온라인 상태의 에이전트만 설정할 수 있습니다.</span>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="$refs._list.refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '검색'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='host';so.skt='Host';so.adv=false;so.sv=''">Host</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='name';so.skt='이름';so.adv=false;so.sv=''">이름</b-dropdown-item>
                <!-- <b-dropdown-item size="sm" @click="so.sk='tag';so.skt='TAG';so.adv=false;so.sv=''">Tag</b-dropdown-item> -->
                <b-dropdown-item size="sm" @click="so.sk='ip_addr';so.skt='IP';so.adv=false;so.sv=''">IP</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" v-show="!so.adv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="12">
          <p class="text-danger font-weight-bold">
            위변조 설정 대상이 많은 경우 모니터링에 실패할 수 있습니다. 최소범위설정을 권장드립니다.
          </p>
        </b-col>
      </b-row>
      <b-table ref="_list" striped hover small fixed :items="getItems" :fields="fields" :current-page="so.currentPage" empty-text="에이전트가 없습니다." :per-page="so.perPage" v-show="this.show" class="text-center table_add">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="ping" slot-scope="row" v-show="this.agents[row.index].ms">
          <b-badge variant="success" v-if="row.item.alive">온라인{{ row.item.ms ? ` (${row.item.ms} ms)` : ''}}</b-badge>
          <b-badge v-else>오프라인</b-badge>
        </template>
        <template slot="name" slot-scope="row"> {{ row.item.name || '-'}}</template>
        <template slot="host" slot-scope="row">{{ row.item.host }}</template>
        <template slot="tag" slot-scope="row">{{ row.item.tag }}</template>>
        <template slot="os_type" slot-scope="row">{{ row.item.os_type }}</template>
        <template slot="ip_addr" slot-scope="row">
          {{row.item.ip_addr_public}} / {{row.item.ip_addr_private}}
        </template>
        <template slot="setting" slot-scope="row">
          <b-badge variant="success" v-if="row.item.setting.forgery_mode || false">사용중</b-badge>
          <b-badge v-else>사용안함</b-badge>
        </template>
        <template slot="select" slot-scope="row">
          <b-button :variant="(row.item.alive ? (model && model.id == row.item.id ? 'danger' : 'primary') : 'secondary')" size="sm" @click="select(row.item)" :disabled="!row.item.alive">
            {{(model && model.id == row.item.id ? '선택함' : '선택')}}
          </b-button>
        </template>
      </b-table>
      <template v-if="!this.show">
        <b-card>
          <tr>
            <th>설정가능한 에이전트가 없습니다.</th>
          </tr>
        </b-card>
      </template>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="so.totalRows" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
    </b-card>
    <b-card  class="text-center" v-if="model && !model.id">
      <span>에이전트를 선택해주세요.</span>
    </b-card>
    <b-card v-else>
      <b-row>
        <b-col md="6">
          <span class="float-left">설치일 : {{model.created_at | datetime }}</span>
          <br>
          <span class="float-left">이름 : {{model.name}} ({{model.host}}@{{model.ip_addr}})</span>
        </b-col>
        <b-col>
          <span class="float-left" @click="model.setting.forgery_mode = !model.setting.forgery_mode" v-b-tooltip.hover title="Can change Enable, if setting complete, auth change Yes" cusor="pointer" style="cursor:pointer">
            상태 :
            <b-badge variant="success" v-if="model.setting.forgery_mode || false">사용중</b-badge>
            <b-badge v-else>사용안함</b-badge>
          </span>
        </b-col>
        <b-col>
          <b-button class="float-right" variant="outline-primary" size="sm" @click="detail()">관리</b-button>
          <b-button class="float-right" variant="outline-warning" size="sm" @click="reset_usage(true)">지우기</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          <center>
            <h5 class="text-danger">* 무결성이 필요한 폴더를 설정하세요 (ex. 설정 폴더 및 백업 폴더)</h5>
          </center>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="text-center" v-if="request">
      <span>
        <i :class="`fa fa-refresh fa-spin`"></i>
        로딩중....
      </span>
    </b-card>
    <folderSet
      v-if="!request && model && model.id"
      :press="press_save"
      :is_refresh="model.alive"
      :show="dir.length"
      :item="dir"
      :scan_list="watching"
      :scan_list_history="watching_history"
      :white_path="white_path"
      :white_file="white_file"
      :white_file_active="true"

      @path="get_path"
      @save="save"
      @remove="remove_select"
      @clear="clear"

      @add_white_list_file="add_white_list_file"
      @add_white_list="add_white_list"
      @add_scan_list="add_watching"

    />
    <br>
    </div>

</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
